var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55103 17.4885C8.69722 17.7416 8.90747 17.9519 9.16066 18.098C9.41385 18.2442 9.70105 18.3212 9.99341 18.3212C10.2858 18.3212 10.573 18.2442 10.8262 18.098C11.0793 17.9519 11.2896 17.7416 11.4358 17.4885",
    stroke: "#4A5565",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7166 12.7632C2.60781 12.8825 2.53602 13.0308 2.50995 13.1901C2.48389 13.3493 2.50468 13.5128 2.56979 13.6605C2.6349 13.8082 2.74153 13.9338 2.87671 14.022C3.01189 14.1102 3.16979 14.1572 3.3312 14.1573H16.6557C16.8171 14.1574 16.9751 14.1105 17.1103 14.0225C17.2456 13.9345 17.3524 13.809 17.4176 13.6614C17.4829 13.5138 17.5039 13.3504 17.4781 13.1911C17.4522 13.0318 17.3806 12.8834 17.272 12.7641C16.1644 11.6223 14.9902 10.409 14.9902 6.66227C14.9902 5.33706 14.4637 4.06613 13.5267 3.12907C12.5896 2.192 11.3187 1.66557 9.99347 1.66557C8.66826 1.66557 7.39733 2.192 6.46026 3.12907C5.5232 4.06613 4.99677 5.33706 4.99677 6.66227C4.99677 10.409 3.82171 11.6223 2.7166 12.7632Z",
    stroke: "#4A5565",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.dee30293926396e3421bc4357a4f66b4.svg";
export { ForwardRef as ReactComponent };